<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import "./css/animate.css";
@import "./css/icomoon.css";
@import "./css/bootstrap.css";
@import "./css/superfish.css";
@import "./css/style.css";
@import url('https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@400;900&display=swap');

#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: 'M PLUS 1p', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue